import { Box, SxProps } from '@mui/material'
import { FunctionComponent } from 'react'
import { CYCLE_STATUS } from 'stores/cycle/types'
import { getCycleStatusLabel } from 'stores/cycle/utils/cycle'
import theme from 'styles/theme'



interface Props {
    cycleStatus: CYCLE_STATUS
    label?: string
}

const CycleStatusBadge: FunctionComponent<Props> = ({ cycleStatus, label }) => (
    <Box sx={sxStatus(cycleStatus)}>
        {label ?? getCycleStatusLabel(cycleStatus)}
    </Box>
)

export default CycleStatusBadge

const sxStatus = (cycleStatus: CYCLE_STATUS): SxProps => {
    const color = {
        [CYCLE_STATUS.NEW]: theme.palette.primary,
        [CYCLE_STATUS.PLANNED]: theme.palette.primary,
        [CYCLE_STATUS.RUNNING]: theme.palette.success,
        [CYCLE_STATUS.HARVESTED]: theme.palette.secondary,
        [CYCLE_STATUS.REJECTED]: theme.palette.error,
    }[cycleStatus]
    return {
        fontSize: "12px",
        fontWeight: 700,
        bgcolor: color?.main,
        color: color?.contrastText,
        textTransform: "uppercase",
        borderRadius: "5px",
        padding: "2px 6px",
    }
}
